<template>
<div>
    <el-row>
        <el-col>
            <el-form :inline='true'>
                <el-form-item label="关键字:" >
                    <el-input placeholder="请输入项目名称" v-model="filters.keyWord" clearable></el-input>
                </el-form-item>
                <el-form-item label="发布状态:" >
                    <el-select v-model="filters.issueStatus" placeholder="请选择发布状态" clearable>
                        <el-option
                            v-for="item in issueStatusArr"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
                </el-form-item>
            </el-form>
        </el-col>
    </el-row>
    <!-- 列表 -->
    <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="listLoading"
        @current-change='currentChange'
        :highlight-current-row='true'
        :header-row-style="{height: '47px'}"
        :cell-style="rowClass"
    >
        <el-table-column type='index' label="序号" width='60' align="center"></el-table-column>
        <el-table-column prop="ExamProjectName" label="项目名称" min-width="170" align="center"></el-table-column>
        <el-table-column prop="Score" label="考试时间" width="350" align="center">
            <template scope="scope">
                <span>{{scope.row.ExamBeginTime}}</span>-
                <span>{{scope.row.ExamEndTime}}</span>
            </template>
        </el-table-column>
        <el-table-column prop="ExamineeScope" label="参与考试人员" min-width="140" align="center">
            <template scope="scope">
                <el-tag v-if="scope.row.ExamineeScope == 0">本级</el-tag>
                <span v-else>-</span>
            </template>
        </el-table-column>
        <el-table-column prop="Status" label="发布状态" min-width="120" align="center">
            <template scope="scope">
                <span v-if="scope.row.Status == 0" style="color: #f56c6c;">未发布</span>
                <span v-if="scope.row.Status == 1" style="color: #409eff;">发布中</span>
                <span v-if="scope.row.Status == 2" style="color: #67c23a;">已发布</span>
            </template>
        </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar" style="height: 80px;margin-top: 12px">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageIndex"
            :page-sizes="pages.pageArr"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.dataCount"
        >
        </el-pagination>
    </el-col>
    <!-- 新增/编辑 -->
    <el-dialog
        :title="isAddOrEdit ? '新增' :'编辑'"
        :visible.sync="examPlanDialog"
        v-model="examPlanDialog"
        :close-on-click-modal="false"
        width="65%"
    >
        <el-form
            :model="examPlanForm"
            label-width="160px"
            :rules="examPlanRules"
            ref="examPlanRef"
        >
            <el-form-item label="项目名称:" prop="projectName">
                <el-input v-model="examPlanForm.projectName" placeholder="请输入项目名称" clearable style="width: 440px;"></el-input>
            </el-form-item>
            <el-form-item label="项目介绍:">
                <el-input v-model="examPlanForm.projectIntro" placeholder="请输入项目介绍" style="width: 440px;" type="textarea" :rows="4"></el-input>
            </el-form-item>
            <el-form-item label="考试开始时间:">
                <el-radio-group v-model="examPlanForm.examStartStatus" @change="statusChange(1)">
                    <el-radio :label="1">不限制时间</el-radio>
                    <el-radio :label="2">选择时间</el-radio>
                </el-radio-group>
                <!-- <br> -->
                <el-date-picker
                    v-model="examPlanForm.examStartTimer"
                    type="datetime"
                    placeholder="选择日期时间"
                    v-if="examPlanForm.examStartStatus == 2"
                    style="margin-left: 15px;"
                    :picker-options="timerRange"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="考试结束时间:">
                <el-radio-group v-model="examPlanForm.examEndStatus" @change="statusChange(2)">
                    <el-radio :label="1">不限制时间</el-radio>
                    <el-radio :label="2">选择时间</el-radio>
                </el-radio-group>
                <!-- <br> -->
                <el-date-picker
                    v-model="examPlanForm.examEndTimer"
                    type="datetime"
                    placeholder="选择日期时间"
                    v-if="examPlanForm.examEndStatus == 2"
                    style="margin-left: 15px;"
                    :picker-options="timerRange"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="参与考试人员:">
                <el-checkbox-group v-model="examPlanForm.joinExam" disabled>
                    <el-checkbox :label="0">本级</el-checkbox>
                    <!-- <el-checkbox :label="1">下级</el-checkbox>
                    <el-checkbox :label="2">本级和下级</el-checkbox> -->
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="试卷名称:" prop="examNameId">
                <el-select v-model="examPlanForm.examNameId" placeholder="请选择试卷名称" clearable style="width: 440px;">
                    <el-option
                        v-for="item in examNameIdArr"
                        :key="item.PaperId"
                        :label="item.PaperName"
                        :value="item.PaperId"
                    >
                    </el-option>
                    <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pages1.pageIndex"
                        :page-sizes="pages1.pageArr"
                        :page-size="pages1.pageSize"
                        layout="prev, pager, next"
                        :total="pages1.dataCount"
                    >
                    </el-pagination>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click.native="examPlanDialog = false">取消</el-button>
            <el-button type="primary" @click.native="examPlanSubmit" :loading="examPlanLoading">提交</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import util from "../../../util/date";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {getInternalExamProjectInfoListPage,saveInternalExamProjectInfo,deleteInternalExamProjectInfo,publishInternalExamProjectInfo,getExamPaperInfoInternalSettingListPage} from '@/api/api'
export default {
	components:{Toolbar},
	data() {
		return {
			buttonList: [],
			filters:{
                keyWord: "",
			},
            issueStatusArr: [
                {value: 0,name: "未发布"},
                {value: 2,name: "已发布"},
            ],
            // 列表
            listLoading: false,
			tableData: [],
            currentRow: '',
			pages: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
            // 新增/编辑
            isAddOrEdit: true,
            examPlanDialog: false,
            examPlanLoading: false,
            examPlanForm: {
                projectName: "",
                projectIntro: "",
                examStartStatus: 1,
                examStartTimer: "",
                examEndStatus: 1,
                examEndTimer: "",
                joinExam: [0],
                examNameId: "",
            },
            examPlanRules: {
                projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
                examNameId: [{ required: true, message: "请选择试卷名称", trigger: "blur" }],
            },
            examNameIdArr: [{}],
            pages1: {
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
            timerRange: {
                disabledDate: time => {
                    return (
                        time < (new Date().setDate(new Date().getDate() - 1)) || time > (new Date().setDate(new Date().getDate() + 90))
                    )
                }
            },
		}
	},
	methods: {
		callFunction(item) {
			this[item.Func].apply(this, item);
		},
		getDataList(){
            let params = {
                examProjectName: this.filters.keyWord,
                status: this.filters.issueStatus,
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
			}
            this.listLoading = true
			getInternalExamProjectInfoListPage(params).then(res => {
				var result = res.data
				if(result.Success){
					this.tableData = result.Response.Data
					this.pages.dataCount = result.Response.DataCount
				}else{
                    this.tableData = []
                    this.pages.dataCount = 0
                }
                this.listLoading = false
			})
		},
		// 查询
		getTableData() {
			this.pages.pageIndex = 1
			this.getDataList();
		},
        // 新增
        handleAdd() {
            this.isAddOrEdit = true
            this.examPlanDialog = true
            this.examPlanLoading = false
            this.examPlanForm =  {
                projectName: "",
                projectIntro: "",
                examStartStatus: 1,
                examStartTimer: "",
                examEndStatus: 1,
                examEndTimer: "",
                joinExam: [0],
                examNameId: "",
            }
        },
        // 编辑
        handleEdit() {
            if(!this.currentRow) {
                this.$message.warning("请先选择要编辑的数据！")
                return
            }
            this.isAddOrEdit = false
            this.examPlanDialog = true
            this.examPlanLoading = false
            this.examPlanForm = {
                projectName: this.currentRow.ExamProjectName,
                projectIntro: this.currentRow.ExamProjectNotes,
                examStartStatus: this.currentRow.ExamBeginTime == "2000-01-01 00:00:00" ? 1 : 2,
                examStartTimer: this.currentRow.ExamBeginTime,
                examEndStatus: this.currentRow.ExamEndTime == "2030-01-01 00:00:00" ? 1 : 2,
                examEndTimer: this.currentRow.ExamEndTime,
                joinExam: [this.currentRow.ExamineeScope],
                examNameId: this.currentRow.ExamPaperInfoId,
            }
        },
        // 编辑提交
        examPlanSubmit() {
            this.$refs.examPlanRef.validate((valid) => {
				if (valid) {
                    if(this.examPlanForm.examStartStatus == 2 && !this.examPlanForm.examStartTimer) {
                        this.$message.warning("请选择考试开始时间！")
                        return
                    }
                    if(this.examPlanForm.examEndStatus == 2 && !this.examPlanForm.examEndTimer) {
                        this.$message.warning("请选择考试结束时间！")
                        return
                    }
                    var params = {
                        Id: 0,
                        ProjectId: 0,
                        ExamProjectName: this.examPlanForm.projectName,
                        ExamProjectNotes: this.examPlanForm.projectIntro,
                        ExamBeginTime: this.examPlanForm.examStartStatus == 2 ? this.formatCreateTime1(this.examPlanForm.examStartTimer) : "2000-01-01 00:00:00",
                        ExamEndTime: this.examPlanForm.examEndStatus == 2 ? this.formatCreateTime1(this.examPlanForm.examEndTimer) : "2030-01-01 00:00:00",
                        ExamineeScope: this.examPlanForm.joinExam[0],
                        ExamPaperInfoId: this.examPlanForm.examNameId,
                    }
                    if(!this.isAddOrEdit) {
                        params.Id = this.currentRow.Id
                        params.ProjectId = this.currentRow.ProjectId
                    }
                    this.examPlanLoading = true
                    saveInternalExamProjectInfo(params).then(res => {
                        var result = res.data
                        if(result.Success) {
                            this.$message.success(result.Message)
                            this.examPlanDialog = false
                            this.getDataList()
                        } else {
                            this.$message.error(result.Message)
                        }
                        this.examPlanLoading = false
                    })
                }
            })
        },
        // 删除
        handleDel() {
            if(!this.currentRow) {
                this.$message.warning("请先选择要删除的数据！")
                return
            }
            this.$confirm('确定删除吗？', '提示', {}).then(() => {
                var params = {
                    Id: this.currentRow.Id
                }
                deleteInternalExamProjectInfo(params).then(res => {
                    var result = res.data
                    if(result.Success) {
                        this.$message.success(result.Message)
                        this.getDataList()
                    } else {
                        this.$message.error(result.Message)
                    }
                })
            }).catch(err => {})
        },
        // 发布
        releaseStatus() {
            if(!this.currentRow) {
                this.$message.warning("请先选择要发布的数据！")
                return
            }
            this.$confirm('确定发布吗？', '提示', {}).then(() => {
                var params = {
                    infoId: this.currentRow.Id,
                    status: 2
                }
                publishInternalExamProjectInfo(params).then(res => {
                    var result = res.data
                    if(result.Success) {
                        this.$message.success(result.Message)
                        this.getDataList()
                    } else {
                        this.$message.error(result.Message)
                    }
                })
            }).catch(err => {})
        },
        // 取消发布
        cancelIssue() {
            if(!this.currentRow) {
                this.$message.warning("请先选择要取消发布的数据！")
                return
            }
            this.$confirm('确定取消发布吗？', '提示', {}).then(() => {
                var params = {
                    infoId: this.currentRow.Id,
                    status: 0
                }
                publishInternalExamProjectInfo(params).then(res => {
                    var result = res.data
                    if(result.Success) {
                        this.$message.success(result.Message)
                        this.getDataList()
                    } else {
                        this.$message.error(result.Message)
                    }
                })
            }).catch(err => {})
        },
        // 时间切换
        statusChange(val) {
            if(val == 1) {
                this.examPlanForm.examStartTimer = ""
            } else if(val == 2) {
                this.examPlanForm.examEndTimer = ""
            }
        },
        // 获取基础数据
        getBaseData() {
            var params = {
				pageIndex: this.pages1.pageIndex,
				pageSize: this.pages1.pageSize,
			}
			getExamPaperInfoInternalSettingListPage(params).then(res => {
				var result = res.data
				if(result.Success){
					this.examNameIdArr = result.Response.Data
					this.pages1.dataCount = result.Response.DataCount
				}else{
                    this.examNameIdArr = []
                    this.pages1.dataCount = 0
                }
			})
        },
		// 点击table某一行
		currentChange(val) {
			this.currentRow = val
		},
		// 分页
		handleCurrentChange(val) {
			this.pages.pageIndex = val;
			this.getDataList();
		},
		handleSizeChange(val){
			this.pages.pageSize = val;
			this.getDataList();
		},
		handleCurrentChange1(val) {
			this.pages1.pageIndex = val;
			this.getBaseData();
		},
		handleSizeChange1(val){
			this.pages1.pageSize = val;
			this.getBaseData();
		},
		// 时间格式化
		formatCreateTime: function(row, column) {
			return !row.CreateTime || row.CreateTime == ""
            ? ""
            : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
		},
		formatCreateTime1: function(row, column) {
			return !row || row == ""
            ? ""
            : util.formatDate.format(new Date(row), "yyyy-MM-dd hh:mm:ss");
		},
		rowClass(){
			return 'padding: 10px 0!important;'
		},
	},
	mounted() {
		let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
		this.buttonList = getButtonList(this.$route.path, routers);
		this.getDataList()
		this.getBaseData()
	}
}
</script>

<style lang="stylus" scoped>

</style>
